// eslint-disable-next-line import/prefer-default-export
export const PATH_PREFIX = '/health';
export const SERVICE_ALIAS = 'rb-life-health';
export const TEXT_OFFER = `/text/${SERVICE_ALIAS}/oferta/1?replace_aliases=true`;
export const TEXT_FOOTER = `/text/${SERVICE_ALIAS}/footer-nosubscribe-health/1`;
export const TEXT_FOOTER_UNDER = `/text/${SERVICE_ALIAS}/footer-under/1`;
export const TEXT_FOOTER_PP = `/text/${SERVICE_ALIAS}/privacyfooter/1`;
export const TEXT_PP = `/text/${SERVICE_ALIAS}/privacypolicy/1`;
